(function () {
	'use strict';

	// Switching to mobile: https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/onchange
	const isMobile = window.matchMedia(
		'(max-width: ' + getComputedStyle(document.body).getPropertyValue('--custom--media-max-width--sm') + ')'
	);
	const navigationResponsiveContainer = document.querySelector(
		'.site-header .wp-block-navigation__responsive-container'
	);
	isMobile.onchange = (e) => {
		if (e.matches) {
			// <= Mobile
		} else {
			// > Mobile
			// Autoclose header nav container if modal is open and browser window gets resized.
			if (
				document.body.contains(navigationResponsiveContainer) &&
				navigationResponsiveContainer.classList.contains('is-menu-open')
			) {
				document.querySelector('.site-header .wp-block-navigation__responsive-container-close').click();
			}
		}
	};

	// Style password protected post form.
	const passwordButton = document.querySelector('.post-password-form [type="submit"]');
	if (document.body.contains(passwordButton)) {
		const passwordButtonWrapper = document.createElement('div');
		passwordButtonWrapper.classList.add('wp-block-button');
		passwordButton.parentNode.insertBefore(passwordButtonWrapper, passwordButton);
		passwordButtonWrapper.appendChild(passwordButton);

		passwordButton.classList.add('wp-block-button__link');
	}

		const triggerSection = document.querySelector('.feature-overlay')
		const countbig = document.querySelector('.count-big')
		const countsmall1 = document.querySelector('.count-small1')
		const countsmall2 = document.querySelector('.count-small2')
		const countsmall3 = document.querySelector('.count-small3')

		gsap.from(countbig, {
		  textContent: 0,
		  duration: 3,
		  snap: { textContent: 2 }, // increment by 1
		  onUpdate: function() {
		      this.targets()[0].innerHTML = numberWithCommas(Math.ceil(this.targets()[0].textContent));
		   },
		  // scrollTrigger: {
		  //   trigger: triggerSection, // trigger section
		  //   start: 'top top', // "start when the top of the element reaches the top of the screen"
		  // },
		})
		gsap.from(countsmall1, {
		  textContent: 0,
		  duration: 3,
		  snap: { textContent: 0.1 }, // increment by 1
		  // scrollTrigger: {
		  //   trigger: triggerSection, // trigger section
		  //   start: 'top top', // "start when the top of the element reaches the top of the screen"
		  // },
		})
		gsap.from(countsmall2, {
		  textContent: 0,
		  duration: 3,
		  snap: { textContent: 0.1 }, // increment by 1
		  // scrollTrigger: {
		  //   trigger: triggerSection, // trigger section
		  //   start: 'top top', // "start when the top of the element reaches the top of the screen"
		  // },
		})
		gsap.from(countsmall3, {
		  textContent: 0,
		  duration: 3,
		  snap: { textContent: 0.1 }, // increment by 1
		  // scrollTrigger: {
		  //   trigger: triggerSection, // trigger section
		  //   start: 'top top', // "start when the top of the element reaches the top of the screen"
		  // },
		})

		function numberWithCommas(x) {
		  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		}

	// Animations on elements with animate classes
		gsap.defaults({ease: "power3"});
		gsap.set(".animate", {y: 20, opacity: 0});

		ScrollTrigger.batch(".animate", {

		  interval: 0.5, // time window (in seconds) for batching to occur. 
		//  batchMax: 3,   // maximum batch size (targets)
		  onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
		  //onLeave: batch => gsap.set(batch, {opacity: 0, y: -100, overwrite: true}),
		  onEnterBack: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
		  //onLeaveBack: batch => gsap.set(batch, {opacity: 0, y: 100, overwrite: true})
		  // you can also define things like start, end, etc.
		 // markers:true
		});

		gsap.set(".animate-multiple div", {y: 20, opacity: 0});

		ScrollTrigger.batch(".animate-multiple div", {

		  interval: 0.5, // time window (in seconds) for batching to occur. 
		//  batchMax: 3,   // maximum batch size (targets)
		  onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
		  //onLeave: batch => gsap.set(batch, {opacity: 0, y: -100, overwrite: true}),
		  onEnterBack: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
		  //onLeaveBack: batch => gsap.set(batch, {opacity: 0, y: 100, overwrite: true})
		  // you can also define things like start, end, etc.
		//  markers:true
		});

		gsap.set(".wp-block-post", {y: 20, opacity: 0});

		ScrollTrigger.batch(".wp-block-post", {

		  interval: 0.5, // time window (in seconds) for batching to occur. 
		//  batchMax: 3,   // maximum batch size (targets)
		  onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
		  //onLeave: batch => gsap.set(batch, {opacity: 0, y: -100, overwrite: true}),
		  onEnterBack: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
		  //onLeaveBack: batch => gsap.set(batch, {opacity: 0, y: 100, overwrite: true})
		  // you can also define things like start, end, etc.
		//  markers:true
		});

})();
